export const DEFAULT_BRAND_PRIMARY = '#d50475'
export const DEFAULT_BRAND_LOGO = '/assets/images/empresas/everhealth.png'
export const DEFAULT_LOGIN_BACKGROUND = '/assets/images/fondo_login2.jpg'
